import HeaderTabsContainer, { TabButton } from '@/header/HeaderTabsContainer';
import { MONEY_DEPOSIT, MONEY_TRANSFER, MONEY_WITHDRAWAL } from '@/routing/routes';
import React from 'react';
import useHeaderTabsScroll from '@/_hooks/useHeaderTabsScroll';

function MyMoneyTabs({ active }) {
    const scrollElementRef = useHeaderTabsScroll();
    return (
        <HeaderTabsContainer>
            <TabButton
                route={MONEY_DEPOSIT}
                i18nCode="menu.registraciadoplnenie"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={MONEY_WITHDRAWAL}
                i18nCode="jsp.osobnaZona.dashboard.vyberZKonta"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={MONEY_TRANSFER}
                i18nCode="menu.transfer"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
        </HeaderTabsContainer>
    );
}

export default MyMoneyTabs;
